import { makeStyles } from '@material-ui/core';
import { RefObject } from 'react';
import { MatchingRoundId } from '../../api/matching-rounds';
import VentureSubgroupSelector, {
  VentureSubgroupSelectorHandle,
} from '../../components/matching-rounds/venture-subgroup-selector';

interface MatchingRoundSubgroupsPageProps {
  roundId: MatchingRoundId;
  selectorRef: RefObject<VentureSubgroupSelectorHandle>;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: '40px 40px 16px',
    minHeight: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      padding: '16px 16px 8px',
    },
  },
}));

function MatchingRoundSubgroupsPage({
  roundId,
  selectorRef,
}: MatchingRoundSubgroupsPageProps) {
  const classes = useStyles();

  return (
    <div data-testid='round-subgroups-page' className={classes.container}>
      <VentureSubgroupSelector ref={selectorRef} roundId={roundId} />
    </div>
  );
}

export default MatchingRoundSubgroupsPage;
